(function(){"use strict";
/* CartaWorld 3D Card Effect v3.0 — Desktop-identical mobile experience */
var CFG={
  maxTilt:20,
  perspective:900,
  spring:.13,
  damping:.72,
  dragSensX:.6,
  dragSensY:.5,
  flipAt:65,
  glare:.38,
  holo:.6,
  returnDelay:150,
  SCROLL_BIAS:2.2   /* ratio dy/dx that confirms vertical scroll intent */
};

/* ─── STYLES ─────────────────────────────────────────────────── */
var css=[
/* Kill Dawn's own image transition / secondary-image swap */
".cw3w .media--hover-effect>img{transition:none!important}",
".cw3w .media--hover-effect>img:first-child:not(:only-child){opacity:1!important;transform:none!important}",
".cw3w .media--hover-effect>img+img{opacity:0!important;transform:none!important}",

/* Wrapper */
".cw3w{position:relative;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}",

/* Drop shadow that deepens on interaction */
'.cw3w::after{content:"";position:absolute;left:8%;right:8%;bottom:-12px;height:20px;background:rgba(0,0,0,.25);filter:blur(12px);border-radius:50%;transform:scaleY(.55);pointer-events:none;z-index:-1;transition:transform .3s,opacity .3s}',
".cw3w.cw3-active::after{transform:scaleY(.85) translateY(5px);opacity:.8}",

/* Scene */
".cw3-scene{position:absolute;inset:0;width:100%;height:100%;perspective:"+CFG.perspective+"px;perspective-origin:center}",

/* Shell — touch-action:none from the start so iOS Safari doesn't swallow our touches */
".cw3-shell{position:relative;width:100%;height:100%;transform-style:preserve-3d;border-radius:inherit;will-change:transform;transform-origin:center;cursor:grab;user-select:none;-webkit-user-select:none;touch-action:none;-webkit-touch-callout:none}",
".cw3-shell.cw3-dragging{cursor:grabbing}",
".cw3-shell.cw3-dragging a,.cw3-shell.cw3-dragging button{pointer-events:none!important}",

/* Faces */
".cw3-face{position:absolute;inset:0;backface-visibility:hidden;-webkit-backface-visibility:hidden;overflow:hidden;border-radius:inherit;display:flex;align-items:center;justify-content:center}",
".cw3-front{transform:rotateY(0deg)}",
".cw3-back{transform:rotateY(180deg)}",
".cw3-face img{display:block;width:100%;height:100%;object-fit:contain;pointer-events:none;user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}",
".cw3-no-back .cw3-back{display:none}",
".cw3-back-badge{position:absolute;top:10px;left:10px;background:rgba(0,0,0,.55);color:#fff;font-size:10px;padding:2px 7px;border-radius:10px;letter-spacing:.05em;pointer-events:none;z-index:5;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)}",

/* Glare — NO hover:none suppression, works the same everywhere */
".cw3-glare{position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:12;opacity:0;transition:opacity .25s;background:radial-gradient(circle at 50% 50%,rgba(255,255,255,.85) 0%,rgba(255,255,255,0) 68%)}",
".cw3-shell.cw3-on .cw3-glare{opacity:1}",

/* Holographic shimmer */
".cw3-holo{position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:11;background:linear-gradient(135deg,rgba(255,0,128,0) 0%,rgba(255,0,128,.13) 20%,rgba(0,255,200,.13) 40%,rgba(0,128,255,.13) 60%,rgba(200,0,255,.13) 80%,rgba(255,0,128,0) 100%);background-size:200% 200%;opacity:0;transition:opacity .3s}",
".cw3-shell.cw3-on .cw3-holo{opacity:"+CFG.holo+";animation:cw3h 3s linear infinite}",
"@keyframes cw3h{0%{background-position:0% 0%}50%{background-position:100% 100%}100%{background-position:0% 0%}}",

/* Edge shine */
".cw3-shine{position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:10;border:1.5px solid rgba(255,255,255,0);transition:border-color .2s}",
".cw3-shell.cw3-on .cw3-shine{border-color:rgba(255,255,255,.2)}",

/* Hint pill */
".cw3-hint{position:absolute;bottom:10px;left:50%;transform:translateX(-50%) translateZ(2px);background:rgba(0,0,0,.62);color:#fff;font-size:12px;letter-spacing:.05em;padding:4px 12px;border-radius:20px;pointer-events:none;z-index:20;opacity:0;transition:opacity .3s;white-space:nowrap;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px)}",
".cw3-shell.cw3-on .cw3-hint{opacity:1}",

/* Flip button — always visible on touch devices */
".cw3-flipbtn{position:absolute;bottom:6px;right:6px;width:44px;height:44px;border-radius:50%;background:transparent;border:none;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:25;padding:0;-webkit-tap-highlight-color:transparent;opacity:0;transition:opacity .2s}",
".cw3-flipbtn-inner{width:30px;height:30px;border-radius:50%;background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);transition:background .15s,transform .15s}",
".cw3-flipbtn svg{pointer-events:none}",
/* Show flip button on hover (desktop) or always on touch screens */
".cw3-shell.cw3-on .cw3-flipbtn{opacity:1}",
"@media (pointer:coarse){.cw3-flipbtn{opacity:1!important}}",
".cw3-flipbtn:active .cw3-flipbtn-inner{background:rgba(255,255,255,.38);transform:scale(1.12)}"
].join("");

var styleEl=document.createElement("style");
styleEl.id="cw3-styles";
document.head.appendChild(styleEl);
styleEl.textContent=css;

var FLIP_SVG='<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 1 0 .49-3.5"/></svg>';

function clamp(v,lo,hi){return Math.min(Math.max(v,lo),hi);}
function lerp(a,b,t){return a+(b-a)*t;}

/* ─── PER-CARD BUILDER ────────────────────────────────────────── */
function buildCard(wrapper){
  if(wrapper.dataset.cw3)return;
  wrapper.dataset.cw3="1";
  wrapper.classList.add("cw3w");

  var mediaDiv=wrapper.querySelector('.card__media,.media,[class*="card__media"]');
  if(!mediaDiv)return;

  var imgs=Array.from(mediaDiv.querySelectorAll("img"));
  if(!imgs.length)imgs=Array.from(wrapper.querySelectorAll("img"));
  if(!imgs.length)return;

  var frontImg=imgs[0];
  var backImg=(imgs.length>1)?imgs[1]:null;

  /* Build DOM */
  var scene=document.createElement("div");scene.className="cw3-scene";
  var shell=document.createElement("div");
  shell.className="cw3-shell"+(backImg?"":" cw3-no-back");
  shell.setAttribute("role","img");
  shell.setAttribute("aria-label",(wrapper.querySelector(".card__heading")||{textContent:"Product"}).textContent.trim());

  var front=document.createElement("div");front.className="cw3-face cw3-front";
  var fImg=frontImg.cloneNode(true);fImg.style.cssText="";front.appendChild(fImg);

  var back=document.createElement("div");back.className="cw3-face cw3-back";
  if(backImg){
    var bImg=backImg.cloneNode(true);bImg.style.cssText="";back.appendChild(bImg);
    var badge=document.createElement("div");badge.className="cw3-back-badge";badge.textContent="BACK";back.appendChild(badge);
  }

  var glare=document.createElement("div");glare.className="cw3-glare";
  var holo=document.createElement("div");holo.className="cw3-holo";
  var shine=document.createElement("div");shine.className="cw3-shine";
  var hint=document.createElement("div");hint.className="cw3-hint";
  hint.textContent=backImg?"Drag to rotate  •  ↺ to flip":"Drag to rotate";

  var flipBtn=null;
  if(backImg){
    flipBtn=document.createElement("button");
    flipBtn.className="cw3-flipbtn";
    flipBtn.type="button";
    flipBtn.setAttribute("aria-label","Flip card");
    var flipInner=document.createElement("div");
    flipInner.className="cw3-flipbtn-inner";
    flipInner.innerHTML=FLIP_SVG;
    flipBtn.appendChild(flipInner);
    shell.appendChild(flipBtn);
  }

  shell.appendChild(front);
  if(backImg)shell.appendChild(back);
  shell.appendChild(glare);
  shell.appendChild(holo);
  shell.appendChild(shine);
  shell.appendChild(hint);
  scene.appendChild(shell);
  mediaDiv.innerHTML="";
  mediaDiv.appendChild(scene);

  /* State */
  var S={
    rotX:0,rotY:0,
    tgtX:0,tgtY:0,
    vX:0,vY:0,
    flipped:false,
    active:false,
    down:false,
    drag:false,
    axis:null,         /* 'h' | 'v' | null */
    startX:0,startY:0,
    lastX:0,lastY:0,
    raf:null,
    timer:null,
    scrollCancelled:false
  };

  /* ── Animation loop ── */
  function tick(){
    var dx=S.tgtX-S.rotX, dy=S.tgtY-S.rotY;
    S.vX=S.vX*CFG.damping+dx*CFG.spring;
    S.vY=S.vY*CFG.damping+dy*CFG.spring;
    S.rotX+=S.vX; S.rotY+=S.vY;
    paint();
    var moving=Math.abs(S.vX)>.003||Math.abs(S.vY)>.003||Math.abs(dx)>.003||Math.abs(dy)>.003;
    S.raf=moving?requestAnimationFrame(tick):null;
    if(!moving){S.rotX=S.tgtX;S.rotY=S.tgtY;paint();}
  }
  function go(){if(!S.raf)S.raf=requestAnimationFrame(tick);}

  function paint(){
    var rX=S.rotX,rY=S.rotY;
    var flipY=S.flipped?180:0;
    if(S.flipped){rX=-rX;rY=-rY;}
    shell.style.transform="rotateX("+rX+"deg) rotateY("+(rY+flipY)+"deg)";
    if(S.active){
      var nx=(rY+CFG.maxTilt)/(CFG.maxTilt*2);
      var ny=(-rX+CFG.maxTilt)/(CFG.maxTilt*2);
      glare.style.background="radial-gradient(circle at "+(18+nx*64)+"% "+(18+ny*64)+"%, rgba(255,255,255,"+CFG.glare+") 0%, rgba(255,255,255,0) 65%)";
      holo.style.backgroundPosition=nx*100+"% "+ny*100+"%";
    }
  }

  function activate(){
    if(S.timer){clearTimeout(S.timer);S.timer=null;}
    S.active=true;
    shell.classList.add("cw3-on");
    wrapper.classList.add("cw3-active");
  }
  function deactivate(delay){
    S.timer=setTimeout(function(){
      S.active=false;
      shell.classList.remove("cw3-on");
      wrapper.classList.remove("cw3-active");
      S.tgtX=0;S.tgtY=0;go();
    },delay||0);
  }

  /* ── POINTER DOWN (mouse + touch) ── */
  function onDown(e){
    if(e.button&&e.button!==0)return;
    if(e.touches&&e.touches.length>1)return;
    S.down=true; S.drag=false; S.axis=null; S.scrollCancelled=false;
    var p=pt(e);
    S.startX=S.lastX=p.x;
    S.startY=S.lastY=p.y;
    if(S.timer){clearTimeout(S.timer);S.timer=null;}
  }

  /* ── POINTER MOVE ── */
  function onMove(e){
    /* Mouse hover (no button pressed) */
    if(!S.down&&e.type==="mousemove"){
      var rect=shell.getBoundingClientRect();
      var mx=(e.clientX-(rect.left+rect.width/2))/(rect.width/2);
      var my=(e.clientY-(rect.top+rect.height/2))/(rect.height/2);
      S.tgtY=clamp(mx*CFG.maxTilt*.65,-CFG.maxTilt,CFG.maxTilt);
      S.tgtX=clamp(-my*CFG.maxTilt*.65,-CFG.maxTilt,CFG.maxTilt);
      activate();go();
      return;
    }

    if(!S.down)return;
    if(e.touches&&e.touches.length>1){cancel();return;}
    if(S.scrollCancelled)return;

    var p=pt(e);
    var dx=p.x-S.startX, dy=p.y-S.startY;
    var adx=Math.abs(dx), ady=Math.abs(dy);

    /* Determine scroll vs drag axis on first 8px of movement */
    if(!S.axis&&(adx>8||ady>8)){
      /* If clearly scrolling vertically and haven't started rotating yet, let scroll happen */
      if(ady>adx*CFG.SCROLL_BIAS){
        S.scrollCancelled=true;
        cancel();
        return;
      }
      S.axis="drag";
      S.drag=true;
      shell.classList.add("cw3-dragging");
      activate();
    }

    if(!S.drag)return;

    /* We own this touch — stop page scroll */
    if(e.cancelable)e.preventDefault();

    S.tgtY=clamp(dx*CFG.dragSensX,-CFG.maxTilt,CFG.maxTilt);
    S.tgtX=clamp(-dy*CFG.dragSensY,-CFG.maxTilt,CFG.maxTilt);
    hint.textContent=backImg&&adx>CFG.flipAt?"Release to flip!":backImg?"Drag to rotate  •  ↺ to flip":"Drag to rotate";
    go();
    S.lastX=p.x; S.lastY=p.y;
  }

  /* ── POINTER UP ── */
  function onUp(e){
    if(!S.down)return;
    S.down=false;
    shell.classList.remove("cw3-dragging");

    if(S.drag){
      var totalDX=S.lastX-S.startX;
      if(backImg&&Math.abs(totalDX)>CFG.flipAt){
        S.flipped=!S.flipped;
        shell.classList.toggle("cw3-flipped",S.flipped);
      }
      hint.textContent=backImg?"Drag to rotate  •  ↺ to flip":"Drag to rotate";
      deactivate(CFG.returnDelay);
    } else {
      /* Pure tap — do nothing (don't deactivate if mouse, let mouseleave handle it) */
      if(e.type==="touchend"||e.type==="touchcancel"){
        deactivate(400);
      }
    }
    S.drag=false; S.axis=null;
  }

  function cancel(){
    S.down=false; S.drag=false; S.axis=null;
    shell.classList.remove("cw3-dragging");
    deactivate(0);
  }

  /* ── Mouse enter/leave for hover tilt ── */
  shell.addEventListener("mouseenter",function(){activate();go();},{passive:true});
  shell.addEventListener("mouseleave",function(){
    if(!S.down){deactivate(0);}
  },{passive:true});

  /* ── Unified event binding ── */
  /* Mouse */
  shell.addEventListener("mousedown",onDown,{passive:true});
  window.addEventListener("mousemove",onMove,{passive:true});
  window.addEventListener("mouseup",onUp,{passive:true});

  /* Touch — touchstart passive=true (we decide later), touchmove passive=false (so we can preventDefault) */
  shell.addEventListener("touchstart",onDown,{passive:true});
  shell.addEventListener("touchmove",onMove,{passive:false});
  shell.addEventListener("touchend",onUp,{passive:true});
  shell.addEventListener("touchcancel",cancel,{passive:true});

  /* Prevent link navigation on drag */
  wrapper.addEventListener("click",function(e){if(S.drag)e.preventDefault();},true);
  wrapper.addEventListener("contextmenu",function(e){if(S.down||S.drag)e.preventDefault();});

  /* ── Flip button ── */
  if(flipBtn){
    function doFlip(){
      S.flipped=!S.flipped;
      shell.classList.toggle("cw3-flipped",S.flipped);
      S.tgtY=S.flipped?-24:24;
      activate();go();
      setTimeout(function(){S.tgtY=0;go();setTimeout(function(){deactivate(0);},500);},260);
    }
    flipBtn.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();doFlip();});
    flipBtn.addEventListener("touchend",function(e){e.preventDefault();e.stopPropagation();doFlip();},{passive:false});
  }

  function pt(e){
    if(e.changedTouches&&e.changedTouches.length)return{x:e.changedTouches[0].clientX,y:e.changedTouches[0].clientY};
    if(e.touches&&e.touches.length)return{x:e.touches[0].clientX,y:e.touches[0].clientY};
    return{x:e.clientX,y:e.clientY};
  }
}

/* ─── INIT ───────────────────────────────────────────────────── */
function initAll(){
  document.querySelectorAll('.card-wrapper,.product-card-wrapper,[class*="card-wrapper"],.product__media,.product-single__media-wrapper').forEach(function(el){buildCard(el);});
}

var obs=new MutationObserver(function(muts){
  muts.forEach(function(m){
    m.addedNodes.forEach(function(n){
      if(n.nodeType!==1)return;
      if(n.matches&&n.matches('.card-wrapper,[class*="card-wrapper"]'))buildCard(n);
      if(n.querySelectorAll)n.querySelectorAll('.card-wrapper,[class*="card-wrapper"]').forEach(buildCard);
    });
  });
});
obs.observe(document.body,{childList:true,subtree:true});

window.addEventListener("orientationchange",function(){
  setTimeout(function(){
    document.querySelectorAll(".card-wrapper[data-cw3]").forEach(function(el){
      var sc=el.querySelector(".cw3-scene");
      if(sc)sc.style.cssText="";
    });
  },300);
});

document.readyState==="loading"?document.addEventListener("DOMContentLoaded",function(){initAll();setTimeout(initAll,600);}):( initAll(),setTimeout(initAll,600));
})();